import { createRouter } from "../modules/common";
import * as user from "./user";

const { Router } = createRouter({
  defaultRoute: "/user",
  routes: [user.root],
});

export const ApplicationRoutes = Router;
